export const MODAL_OPEN = 'ModalV:Modal';
export const MODAL_CLOSE= 'ModalV:ModalClose';